import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  GENERAL_SETTINGS,
  SCANPACK_SETTINGS,
  USER_INFO_SUCCESS,
  GET_BOTH_SETTINGS,
  USER_INFO_SUCCESS_FAIL,
  GET_BOTH_SETTINGS_FAIL,
  SEND_PASSWORD_RESET_EMAIL,
  SEND_PASSWORD_RESET_EMAIL_FAIL,
  IS_EMAIL_SEND,
  IS_BUG_SUPPORT_POPUP_OPEN,
  GET_ALL_USERS,
  UPLOAD_SOUND_FAIL,
  UPLOAD_SOUND_SUCCESS,
  FETCH_SOUND_SUCCESS,
  FETCH_SOUND_FAIL,
  REMOVE_SOUND_FAIL,
  REMOVE_SOUND_SUCCESS,
  SET_USER_INFO
} from '../constants';
import completeSound from '../../assets/sounds/_order_complete.mp3';
import scanSuccessSound from '../../assets/sounds/Scann Success_coin_a.mp3';
import scanFailSound from '../../assets/sounds/scan_fail_shorter.mp3';
import reloadPage from '../utils/reloadPage';

export function Login(data, str) {
  return async dispatch => {
    try {
      const url = await AsyncStorage.getItem('url');

      const res = await axios({
        method: 'post',
        url: `${url}/oauth/token`,
        headers: {},
        data: data?.data
      });

      // An earlier user's userInfo must never pair with this token; main.js refetches when it is absent.
      await AsyncStorage.removeItem('userInfo');
      await dispatch(UpdateLoginTime(data, res, data?.data?.username));

      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.status,
        time: new Date()
      });

      await AsyncStorage.setItem('access_token', res.data.access_token);
      Logging();
    } catch (error) {
      dispatch({
        type: LOGIN_FAIL,
        payload: error?.response?.status,
        data: error?.response?.data
      });
      throw error;
    }
  };
}


const Logging = async () => {
  let arr = JSON.stringify([]);
  await AsyncStorage.setItem('Logging', arr);
};

export function UserInfo(call) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/home/userinfo.json`,
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(async res => {
        let data = JSON.stringify(res.data);
        await AsyncStorage.setItem('userInfo', data);
        await AsyncStorage.setItem('userId', res.data.id);
        call === false
          ? dispatch({
              type: USER_INFO_SUCCESS_FAIL,
              payload: res.data
            })
          : dispatch({
              type: USER_INFO_SUCCESS,
              payload: res.data
            });
      })
      .catch(error => {
        if (error?.response?.status == '401') {
          dispatch({
            type: USER_INFO_SUCCESS_FAIL,
            payload: error.response.status
          });
        }
      });
  };
}

export const USERINFO_TIMEOUT_MS = 10000;

export async function fetchAndStoreUserInfo(url, accessToken) {
  let timer;
  // The post-login reload and Main's first render both wait on this, so a hung request must fail.
  const timeout = new Promise((resolve, reject) => {
    timer = setTimeout(
      () => reject(new Error(`userinfo.json timed out after ${USERINFO_TIMEOUT_MS}ms`)),
      USERINFO_TIMEOUT_MS
    );
  });
  let res;
  try {
    res = await Promise.race([
      axios({
        method: 'get',
        url: `${url}/home/userinfo.json`,
        headers: {Authorization: `Bearer ${accessToken}`}
      }),
      timeout
    ]);
  } finally {
    clearTimeout(timer);
  }
  await AsyncStorage.setItem('userInfo', JSON.stringify(res.data));
  await AsyncStorage.setItem('userId', res.data.id);
  return res.data;
}

export function GetBothSettings() {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
  return  axios({
      method: 'get',
      url: `${url}/settings/get_setting.json`,
      headers: {Authorization: `Bearer ${access_token}`}
    })
    .then(async res => {
      if(res?.data?.data?.select_types){
        const settingLabelKeyMap = {
          correct_scan: 'correctScanLabel',
          error_scan: 'errorScanLabel',
          order_done: 'orderScanLabel'
        };
        const storageKeyMap = {
          correct_scan: 'correctScanType',
          error_scan: 'errorScanType',
          order_done: 'orderScanType'
        };
        const defaultSounds = {
          correct_scan: scanSuccessSound,
          error_scan: scanFailSound,
          order_done: completeSound
        }

        res.data.data?.select_types.forEach(async ({select_type, url})=> {
          let fileName , defaultLabel

          if(url){
            fileName = url.split('/').pop().split('.').slice(0, -1).join('.');
          }else{
            url = defaultSounds[select_type]
             defaultLabel = 'Default Sound'
          }
          await AsyncStorage.setItem(storageKeyMap[select_type], url);
          await AsyncStorage.setItem(settingLabelKeyMap[select_type], defaultLabel?? fileName);
        })
      }
      if(res?.data?.data?.general_setting?.new_time_zone){
        await AsyncStorage.setItem('new_time_zone', res.data.data.general_setting.new_time_zone);
      }
      dispatch({
          type: GET_BOTH_SETTINGS,
          payload: {data: res.data, time: new Date()}
        });
        return res.data
      })
      .catch(error => {
        dispatch({
          type: GET_BOTH_SETTINGS_FAIL,
          payload: {data: error?.response?.status, time: new Date()}
        });
      });
  };
}

export function GetGeneralSetting(callBack) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/settings/get_settings.json`,
      headers: {Authorization: `Bearer ${access_token}`}
    })
    .then(async res => {
      await AsyncStorage.setItem('Packing_slip_size',res?.data.data.settings.packing_slip_size);
      await AsyncStorage.setItem('Product_Barcode_label_size',res?.data.data.settings.product_barcode_label_size);

      // Store loggly_gpx_order_scan setting for logging control
      if(res?.data?.loggly_gpx_print_label !== undefined) {
        await AsyncStorage.setItem('loggly_gpx_order_scan', res?.data?.loggly_gpx_print_label.toString());
      }

        dispatch({
          type: GENERAL_SETTINGS,
          payload: {data: res.data, time: new Date()}
        });
        if(callBack) callBack();
      })
      .catch(error => {});
  };
}

export function UpdateSettings(payload) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    return axios({
      method: 'put',
      url: `${url}/settings/update_settings.json`,
      headers: {Authorization: `Bearer ${access_token}`},
      data: payload
    })
      .then(res => {
        dispatch(GetBothSettings())
        if (res?.data?.status === false) {
          return {ok: false, errorMessages: res.data.error_messages || []};
        }
        return {ok: true};
      })
      .catch(error => ({ok: false, error, errorMessages: error?.response?.data?.error_messages || []}));
  };
}

export function GetScanPackSetting() {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    axios({
      method: 'get',
      url: `${url}/settings/get_scan_pack_settings.json`,
      headers: {Authorization: `Bearer ${access_token}`}
    })
      .then(res => {
        dispatch({
          type: SCANPACK_SETTINGS,
          payload: {data: res.data, time: new Date()}
        });
      })
      .catch(error => {});
  };
}

export function UpdateScanPackSettings(payload, callback) {
  return async dispatch => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');

      const response = await axios({
        method: 'post',
        url: `${url}/settings/update_scan_pack_settings`,
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json'
        },
        data: payload
      });

      if (response.data.status) {
        dispatch(GetScanPackSetting());
        dispatch(GetBothSettings());
      }
      if (callback) {
        callback({
          success: response.data.status === true,
          errorMessages: response.data.error_messages || []
        });
      }
    } catch (error) {
      if (callback) {
        callback({
          success: false,
          errorMessages: error?.response?.data?.error_messages || []
        });
      }
    }
  };
}

export function ResetPassword(data) {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');
    dispatch({
      type: IS_EMAIL_SEND,
      payload: true
    });
    axios({
      method: 'get',
      url: `${url}/users/get_user_email?user=${data.name}`,
      headers: {Authorization: `Bearer ${access_token}`}
    })
      .then(data => {
        dispatch({
          type: SEND_PASSWORD_RESET_EMAIL_FAIL,
          payload: false
        });
        dispatch({
          type: SEND_PASSWORD_RESET_EMAIL,
          payload: data.data.msg
        });
        dispatch({
          type: IS_EMAIL_SEND,
          payload: false
        });
      })
      .catch(error => {
        dispatch({
          type: SEND_PASSWORD_RESET_EMAIL_FAIL,
          payload: true
        });
        dispatch({
          type: IS_EMAIL_SEND,
          payload: false
        });
      });
  };
}
export function SetEmailSend() {
  return async dispatch => {
    dispatch({
      type: IS_EMAIL_SEND,
      payload: ''
    });
  };
}


export function UpdateLogoutTime() {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const tenent = await AsyncStorage.getItem('tenent');
    const url = await AsyncStorage.getItem('url');
    const logout_time = new Date().toISOString();
    axios
      .post(`${url}/users/update_logout_time.json`, {logout_time :logout_time}, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',
          tenent: tenent
        }
      })
      .then(response => {
        console.log('response', response);
      })
      .catch(error => {
        console.log('error', error);
      });
  };
}

export function UpdateLoginTime(tenantName, tokenA, username) {
  let token = tokenA.data.access_token

  return async dispatch => {
    const access_token =token ? token : await AsyncStorage.getItem('access_token');
    const tenent = tenantName.tenent ? tenantName.tenent : await AsyncStorage.getItem('access_token');
    await AsyncStorage.getItem('tenent');
    const url = await AsyncStorage.getItem('url');
    axios
      .post(`${url}/users/update_login_date`, {username}, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(async () => {
        // main.js picks the landing route from persisted userInfo after this reload: store it
        // first, or leave it absent so main.js refetches.
        const stored = await fetchAndStoreUserInfo(url, access_token).then(
          () => true,
          () => false
        );
        if (!stored) await AsyncStorage.removeItem('userInfo');
        reloadPage();
      })
      .catch(error => {
            console.log('error', error);
      });
  };
}



export function setBugOrSupportPopUP() {
  return async dispatch => {
    dispatch({
      type: IS_BUG_SUPPORT_POPUP_OPEN,
      payload: true
    });
  };
}

export function resetBugOrSupportPopUP() {
  return async dispatch => {
    dispatch({
      type: IS_BUG_SUPPORT_POPUP_OPEN,
      payload: false
    });
  };
}

export function GetAllUsers() {
  return async dispatch => {
    const access_token = await AsyncStorage.getItem('access_token');
    const url = await AsyncStorage.getItem('url');

    axios({
      method: 'get',
      url: `${url}/users.json`,
      headers: {Authorization: `Bearer ${access_token}`}
    })
      .then(response => {
        dispatch({
          type: GET_ALL_USERS,
          payload: response.data
        });
      })
      .catch(error => {
        console.error('Error fetching users:', error);
      });
  };
}

export function addSoundFile(formData) {
  return async dispatch => {
    const url = await AsyncStorage.getItem('url');
    const access_token = await AsyncStorage.getItem('access_token');
    const tenent = await AsyncStorage.getItem('tenent');

    axios
      .post(`${url}/sound_files/create_sounds`, formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'multipart/form-data',
          tenent: tenent
        }
      })
      .then(response => {
        console.log('response', response);
        dispatch({
          type: UPLOAD_SOUND_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        console.log('error', error);
        dispatch({
          type: UPLOAD_SOUND_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function fetchSounds() {
  return async dispatch => {
    const url = await AsyncStorage.getItem('url');
    const access_token = await AsyncStorage.getItem('access_token');
    const tenent = await AsyncStorage.getItem('tenent');
    console.log('url', url);
    console.log('response', access_token);
    console.log('tenent', tenent);

    axios
      .get(`${url}/sound_files/get_sounds_files`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'multipart/form-data',
          tenent: tenent
        }
      })
      .then(response => {
        console.log('response', response);
        dispatch({
          type: FETCH_SOUND_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        console.log('error', error);
        dispatch({
          type: FETCH_SOUND_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function removeSounds(soundType, fileNames) {
  return async dispatch => {
    const url = await AsyncStorage.getItem('url');
    const access_token = await AsyncStorage.getItem('access_token');
    const tenant = await AsyncStorage.getItem('tenant');
    // Construct the payload
    const payload = {
      sound_type: soundType,
      file_names: fileNames
    };

    axios
      .delete(`${url}/sound_files/remove_sounds`, {
        data: JSON.stringify(payload),  // Send data in the request body
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'application/json',  // Change to JSON content type
          tenant: tenant
        }
      })
      .then(response => {
        console.log('response', response);
        dispatch({
          type: REMOVE_SOUND_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        console.log('error', error);
        dispatch({
          type: REMOVE_SOUND_FAIL,
          payload: error?.response?.status
        });
      });
  };
}

export function GetBoxChampSortPreference() {
  return async () => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      const res = await axios({
        method: 'get',
        url: `${url}/settings/get_columns_state?identifier=boxchamp_sort`,
        headers: {Authorization: `Bearer ${access_token}`}
      });
      return res?.data?.data?.theads === 'packing' ? 'packing' : 'location';
    } catch (error) {
      return 'location';
    }
  };
}

export function SaveBoxChampSortPreference(mode) {
  return async () => {
    try {
      const access_token = await AsyncStorage.getItem('access_token');
      const url = await AsyncStorage.getItem('url');
      await axios({
        method: 'post',
        url: `${url}/settings/save_columns_state`,
        headers: {Authorization: `Bearer ${access_token}`},
        data: {identifier: 'boxchamp_sort', theads: mode}
      });
    } catch (error) {
      // non-blocking — a persistence failure must never break packing
    }
  };
}

export function setUserInfo(userInfo) {
  return dispatch => {
    dispatch({
      type: SET_USER_INFO,
      payload: userInfo
    });
  };
}

export function fetchUserInfo() {
  return async dispatch => {
    try {
      const info = await AsyncStorage.getItem('userInfo');
      const userInfo = info ? JSON.parse(info) : null;
      dispatch(setUserInfo(userInfo));
    } catch (error) {
      dispatch(setUserInfo(null));
    }
  };
}

